<template>
  <div class="benefit">
    <Card padding="0px">
      <div class="benefit__content">
        <div class="benefit__content--left">
          <h3>{{ headline }}</h3>
          <div class="greenline"></div>
          <p>{{ description }}</p>
        </div>
        <div class="benefit__content--right">
          <img :src="illustration" alt="Benefit illustration">
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import Card from '../Card/Card';

export default {
  name: 'Benefit',
  components: {
    Card,
  },
  props: {
    headline: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    illustration: {
      required: false,
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Benefit.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Benefit/Benefit.vue